import { render } from "./TeacherList.vue?vue&type=template&id=646b2520&ts=true"
import script from "./TeacherList.vue?vue&type=script&lang=ts"
export * from "./TeacherList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__